
import React from 'react';
import Users from './images/users.png';

const Icon1 = () => {
    return (
        <div className="container-fluid">
            <img src={Users} alt="users icon" className="img-fluid" style={{width: "100%"}} />
        </div>
    )
}

export default Icon1